import { render, staticRenderFns } from "./ScoringPanelistsPage.vue?vue&type=template&id=0dd6a06c"
import script from "./ScoringPanelistsPage.vue?vue&type=script&lang=ts"
export * from "./ScoringPanelistsPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports